var prismanoteApp = angular.module('prismanoteApp', [
	'ngAnimate',
	'angularUtils.directives.dirPagination',
	'ui.bootstrap',
	'ui.router',
	'angular.filter',
	'angularUtils.directives.dirPagination',
	'validation.match',
	'ngSanitize',
	'ngCookies',
	'pascalprecht.translate',
	'toggle-switch',
	'angucomplete-alt',
	'cgPrompt',
	'dndLists',
	'ngFileUpload',
	'ui.router.breadcrumbs',
	'angular-bind-html-compile',
	'rzModule', // range slider (i.e. for price filter)
	'ngFileSaver',
	'angular-input-stars',
	'textAngular',
	'ui.bootstrap.datetimepicker',
	'angular-intro',
	'colorpicker.module',
	'uiCropper',
	'isoCurrency',
	'ngDraggable',
	'indexedDB',
	'angularFileUpload',
	'dialogs.main',
	'bootstrapLightbox',
	'ngIdle',
	'ui.select',
	'isteven-multi-select',
	// 'btford.socket-io',
	'selectize',
	'angular-jsoneditor'
]);

prismanoteApp.constant('_', _);

function getAwsURL() {
	var result = "https://prismanote.s3.amazonaws.com/";

	if (
		window.location.hostname === 'localhost' ||
		window.location.hostname === "127.0.0.1" ||
		window.location.hostname === "goedenoot.nl" ||
		window.location.hostname === "www.goedenoot.nl" ||
		window.location.hostname === 'qqwatches.nl' ||
		window.location.hostname === 'www.qqwatches.nl' ||
		window.location.hostname === "prisma.note" ||
		window.location.hostname === "www.prisma.note"
	) {
		result = "https://prismanotetest.s3.amazonaws.com/"
	}
	return result;
}

prismanoteApp.config(['$provide', '$httpProvider', 'LightboxProvider', 'IdleProvider', 'TitleProvider', '$translateProvider', '$qProvider',
	function ($provide, $httpProvider, LightboxProvider, IdleProvider, TitleProvider, $translateProvider, $qProvider) {
		$httpProvider.interceptors.push('apiInterceptor');
		$qProvider.errorOnUnhandledRejections(false);

		$provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$uibModal', 'taSelection', function (taRegisterTool, taOptions, $uibModal, taSelection) {
			taRegisterTool('uploadImage', {
				buttontext: 'Afbeelding',
				iconclass: "fa fa-image",
				action: function (deferred, restoreSelection) {

					var modalInstance = $uibModal.open({
						templateUrl: '../views/modal/textAngular-upload-image-modal.html',
						controller: 'textAngularTextUploadModalController',
					});
					modalInstance.result.then(function (result) {
						restoreSelection();
						document.execCommand('insertImage', true, result);
						deferred.resolve();
					}, function () {
						deferred.resolve();
					})
					return false;
				}
			});
			taOptions.toolbar[3].push('uploadImage');

			taRegisterTool('placeholder_firstName', {
				buttontext: 'Voornaam',
				action: function (deferred, restoreSelection) {
					restoreSelection()
					taSelection.insertHtml('[[firstName]]')
				}
			})
			taRegisterTool('placeholder_prefix', {
				buttontext: 'Tussenvoegsel',
				action: function (deferred, restoreSelection) {
					restoreSelection()
					taSelection.insertHtml('[[prefix]]')
				}
			})
			taRegisterTool('placeholder_lastName', {
				buttontext: 'Achternaam',
				action: function (deferred, restoreSelection) {
					restoreSelection()
					taSelection.insertHtml('[[lastName]]')
				}
			})
			taRegisterTool('placeholder_fullName', {
				buttontext: 'Volledige naam',
				action: function (deferred, restoreSelection) {
					restoreSelection()
					taSelection.insertHtml('[[fullName]]')
				}
			})
			taRegisterTool('placeholder_salutation', {
				buttontext: 'Aanhef',
				action: function (deferred, restoreSelection) {
					restoreSelection()
					taSelection.insertHtml('[[salutation]]')
				}
			})
			taRegisterTool('placeholder_address', {
				buttontext: 'Volledig adres',
				action: function (deferred, restoreSelection) {
					restoreSelection()
					taSelection.insertHtml('[[fullAddress]]')
				}
			})
			return taOptions;
		}]);


		LightboxProvider.getImageUrl = function (image) {
			if (image.src.indexOf("http") !== -1) {
				return image.src;
			} else {
				return getAwsURL() + image.src;
			}
		}

		IdleProvider.idle(60); // 120 > 2 minutes
		IdleProvider.timeout(5); // 25
		TitleProvider.enabled(false);

		// angular.extend(toastrConfig, {
		// 	autoDismiss: true,
		// 	positionClass: 'toast-bottom-right'
		// });
	}]);

prismanoteApp.run(['$rootScope', '$window', '$location', 'dialogs', '$api', '$translate', '$transitions', '$state', '$language', 'Idle', '$employee', '$retailer', '$q', 'prompt', '$interval', '$uibModal', '$device',
	function ($rootScope, $window, $location, dialogs, $api, $translate, $transitions, $state, $language, Idle, $employee, $retailer, $q, prompt, $interval, $uibModal, $device) {

		// $rootScope.showDashboardAlert = true
		//
		// $rootScope.closeDashboardAlert = function () {
		// 	$rootScope.showDashboardAlert = false
		// }

		checkEmployeeAuth();

		function checkEmployeeAuth(){
			var shopSlug = localStorage.getItem('currentShop');
			$retailer.getShop()
				.then(function (shop) {
					$rootScope.currentShop = shop;
					var companySlug = localStorage.getItem('currentCompany');
					var data = { reload: true, shopSlug: shopSlug, companySlug: companySlug }
					checkLogin(data, function (err, user) {
						if(user && user.role && (user.role == "retailer") && $rootScope.currentShop && $rootScope.currentShop.employeeLockSecurity) {
							if($rootScope.checkEmployeeModalNecessity(user)) {
								$employee.openUnlockModal()
							}
						}
					})
				})
				.catch( function (reason) {
					console.error('Error getting shop', reason)
				})
		}
		
		$rootScope.defaultToolbar = [
			['p', 'h1', 'h2', 'h3', 'justifyLeft', 'justifyCenter', 'justifyRight'],
			['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol'],
			['insertLink', 'html', 'uploadImage'],
			['undo', 'redo', 'clear'],
			['wordcount', 'charcount']
		]

		$rootScope.openRetalierShowModal = function (productId) {
			var shopId = $rootScope.currentShop._id;
			var productId = productId;

			return $q(function (resolve, reject) {
				var data = {
					'shopId': shopId,
					'productId': productId,
				};
				var modalInstance = $uibModal.open({
					templateUrl: '../views/modal/retailer-shop-product-show-modal.html',
					controller: 'retailerShopProductShowController',
					size: 'md',
					resolve: {
						data: function () {
							return data;
						}
					}
				});

				modalInstance.result
					.then(function (response) {
					})
					.catch(function (reason) {
						reject(reason);
					});
			});
		}

		$rootScope.connectionLosed = false
		$rootScope.lastActivityTime = new Date()
		$rootScope.missingTranslations = []

		$rootScope.tillMode = window.location.host === 'kassa.prismanote.com' || window.location.host === '127.0.0.1:8080'
		if($rootScope.tillMode) {
			console.info('App is running in tillmode now')
		}
		$(document).ready(function () {
			setTimeout(function () {
				if (localStorage.getItem('menuCollapsed') && (!$rootScope.mobile && !$rootScope.tablet)) {
					var scoopElement = document.querySelector('#scoop');
					if (scoopElement) {
						$rootScope.menuState = localStorage.getItem('menuCollapsed')
						scoopElement.setAttribute('vertical-nav-type', $rootScope.menuState)
					}
				}
			}, 1000)

			if ((window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1')) {
				var override = localStorage.getItem('enableLogger')
				if (!override || override === false || override === 'false') {
					// console.info('Only console.info and error are available in production mode now')
					logger.disableLogger()
				}
			}

			setTimeout(function () {
				//Check if device is attached
				$retailer.getShop()
					.then(function () {
						$device.getCurrentDevice()
					})
			}, 500)
		})

		// Here, we are checking that if employee login is there then what type of the access they have. so they can go there or not
		$rootScope.hasAccessToViewPage = function () {
			// if (!rights) return;
			var canAccess = false;
			var currentRights = ($state.$current && $state.$current.data && $state.$current.data.rights ? $state.$current.data.rights : undefined);
			if ($rootScope.currentEmployee && $rootScope.currentEmployee.shopRights && $rootScope.currentEmployee.shopRights.length && currentRights) {
				// Only check the rights on the user when they are there. Because 0 rights means full access
				var shopRightsLength = $rootScope.currentEmployee.shopRights.length;
				for (var i = 0; i < shopRightsLength; i++) {
					if ($rootScope.currentEmployee.shopRights[i].name === currentRights && $rootScope.currentEmployee.shopRights[i].enabled) {
						canAccess = true;
						break;
					}
				}
			} else {
				canAccess = true;
			}

			return canAccess;
		}

		// Purchase Order, refreshing page then we give alert message
		$rootScope.$on('$locationChangeStart', function (event, toUrl, fromUrl) {

			var canAccess = $rootScope.hasAccessToViewPage();
			// if (!canAccess) $state.go('retailer.home');
			if (!canAccess) {
				return $state.go('retailer.no-rights');
			}
			var parser = document.createElement('a');
			var parserToUrl = document.createElement('a');
			parserToUrl.href = toUrl;
			parser.href = fromUrl;
			var splitArray = parser.pathname.split('/');
			var splitArrayToUrl = parserToUrl.pathname.split('/');
			if (splitArray.length === 4) {
				var pathname = splitArray[1] + '/' + splitArray[2];
				var pathnameToUrl = splitArrayToUrl[1] + '/' + splitArrayToUrl[2];
				if (pathname === 'retailer/purchase-order' || pathname === 'brand/purchase-order') {
					$rootScope.isPurchaseOrderNew = false;
					$rootScope.companyLogo = undefined;
				} else if (pathname === 'retailer/supplier') {
					$rootScope.companyLogo = undefined;
				}

				if ((pathname === 'brand/recommendation-order' && pathnameToUrl !== 'brand/recommendation-order') ||
					pathname === 'retailer/recommendation-order' && pathnameToUrl !== 'retailer/recommendation-order') {
					localStorage.removeItem('recommendationFilter');
					$rootScope.recommendationOrderSearchValue = undefined;
				}
			}
			//Check device on page change
			$retailer.getShop()
				.then(function () {
					$device.getCurrentDevice()
				})
		});

		$rootScope.$watch(function () {return $location.path()}, function (newLocation, oldLocation) {
			var canAccess = $rootScope.hasAccessToViewPage();
			if (!canAccess) {
				return $state.go('retailer.no-rights');
			}
		});

		// Purchase Order, refreshing page then we are giving alert message
		window.onbeforeunload = function (event) {
			// If new purchase order and yet not created in DB(isPurchaseOrderNew)
			if ($rootScope.isPurchaseOrderNew) {
				var message = 'Sure you want to leave?';
				return message;
			}
		}

		// setInterval(function () {
		// 	//push every 30 minutes the missing translations to the server
		// 	if($rootScope.connectionLosed) {
		// 	  return
    //   }
		// 	$api.post('translations/missing', {
		// 		translations: $rootScope.missingTranslations
		// 	}, null, 2)
		// 		.then(function (result) {
		// 			console.info('Missing keywords sended to server and handled')
		// 		})
		// 		.catch(function (reason) {
		// 			console.error('error while pushing missing translations to server', reason)
		// 		})
		// }, 1800000)

		// detect user window size on resize
		angular.element($window).on('resize', function () {
			$rootScope.setWindowSize($window.innerWidth);
		});

		$rootScope.checkMobile = function () {
			var check = false;
			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);
			return check;
		}

		$rootScope.checkMobileAndTablet = function () {
			var check = false;
			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);
			return check;
		}

		$rootScope.toggleSidebar = function (side) {
			if (!$rootScope.mobile && !$rootScope.tablet) {
				$rootScope.menuState = angular.element('#scoop').attr("vertical-nav-type");
				localStorage.setItem('menuCollapsed', $rootScope.menuState);
			} else {
				if (side) {
					var scoopElement = document.querySelector('#scoop');
					if (scoopElement) {
						$rootScope.menuState = $rootScope.mobile ? 'offcanvas' : 'collapsed'
						scoopElement.setAttribute('vertical-nav-type', $rootScope.menuState)
					}
				}
			}
		}

		$rootScope.serverDownIntervalCanceller = null
		$rootScope.reconnectIntervalCanceller = null
		$rootScope.serverDownStatusText = $language.translate('RECONNECTING')
		$rootScope.intervalInitialValue = 5
		$rootScope.intervalCycleCounter = 0
		$rootScope.pingTest = function(host) {
			return $q(function (resolve, reject) {
				ping(host)
					.then(function () {
						return resolve()
					})
					.catch(function (err) {
						console.error('pingTest failed with reason:', err)
						return reject()
					})
			})
		}

		// We are initializing this from the retailer-controller and brand-controller
		// $rootScope.socketInit = function () {
		// 	SocketService.on('connect', function() {
		// 		// $rootScope.connectionLosed = false
		// 		// $interval.cancel($rootScope.serverDownIntervalCanceller)
		// 		// $rootScope.serverDownIntervalCanceller = null
		// 		// $rootScope.serverDownIntervalValue = 0
		// 		//toastr.clear()
		// 	})
		//
		// 	SocketService.on('disconnect', function () {
		// 		// setTimeout(function () {
		// 		// 	$rootScope.connectionLosed = true
		// 		// 	// toastr.clear()
		// 		// 	// toastr.error($language.translate('PLEASE_WAIT_WHILE_WE_TRY_RECONNECT'),$language.translate('CONNECTION_LOSED'), {timeOut:0,extendedTimeOut:0 })
		// 		// 	$rootScope.reconnectIntervalValue = $rootScope.intervalInitialValue
		// 		// 	$rootScope.serverDownIntervalValue = 0
		// 		// 	$rootScope.intervalCycleCounter = 0
		// 		// 	$rootScope.pingTest('https://google.com')
		// 		// 		.then(function() {
		// 		// 			//Host is reachable, server is not reachable
		// 		// 			$rootScope.reconnectIntervalCanceller = $interval(function() {
		// 		// 				$rootScope.reconnectIntervalValue -= 1
		// 		// 			}, 1000)
		// 		// 			$rootScope.serverDownIntervalCanceller = $interval(function(){
		// 		// 				$rootScope.serverDownIntervalValue++
		// 		// 				if($rootScope.intervalCycleCounter < 10) {
		// 		// 					if ($rootScope.reconnectIntervalValue !== 0) {
		// 		// 						$rootScope.serverDownStatusText = $language.translate('RECONNECTING_IN') + ' ' + $rootScope.reconnectIntervalValue + ' ' + $language.translate(($rootScope.reconnectIntervalValue === 1 ? 'SECOND' : 'SECONDS'))
		// 		// 					} else {
		// 		// 						$rootScope.intervalCycleCounter++
		// 		// 						$rootScope.reconnectIntervalValue = $rootScope.intervalCycleCounter * $rootScope.intervalInitialValue
		// 		// 					}
		// 		// 				} else {
		// 		// 					$interval.cancel($rootScope.reconnectIntervalCanceller)
		// 		// 					$rootScope.reconnectIntervalCanceller = null
		// 		// 					$rootScope.serverDownStatusText = $language.translate('RECONNECTING_FAILED_PLEASE_WAIT_OR_CONTACT_SUPPORT')
		// 		// 				}
		// 		// 			}, 1000)
		// 		// 		}).catch(function(){
		// 		// 		//Host is not reachable, internet connection is propably not availables
		// 		// 		$rootScope.serverDownStatusText = $language.translate('CHECK_YOUR_CONNECTION')
		// 		// 	})
		// 		// }, 2000)
		// 	})
		//
		// 	if ($rootScope.currentShop) {
		// 		var currentNameSlug = localStorage.getItem('currentShop');
		// 		SocketService.on('shop:' + currentNameSlug + ':notifications:new', function (data) {
		// 			sendBrowserNotification(data.message[$rootScope.language]);
		// 			$rootScope.currentShop.notifications.push(data);
		//
		// 			$rootScope.$apply();
		// 			var media = '/public/media/notification.mp3'
		// 			var audio = new Audio(media);
		// 			audio.play();
		// 		})
		//
		// 		SocketService.on('shop:' + currentNameSlug + ':messagenotifications:new', function (data) {
		// 			sendBrowserNotification(data.message[$rootScope.language]);
		// 			$rootScope.currentShop.messageNotification.unshift(data);
		//
		// 			$rootScope.$apply();
		// 			var media = '/public/media/notification.mp3'
		// 			var audio = new Audio(media);
		// 			audio.play();
		// 		})
		//
		// 		SocketService.on('shop:' + currentNameSlug + ':notifications:unread', function (data) {
		// 			$rootScope.unreadNotifications = data;
		// 			$rootScope.changeTitle();
		// 		})
		//
		// 		SocketService.on('shop:' + currentNameSlug + ':messagenotifications:unread', function (data) {
		// 			if (!$rootScope.unreadMessageNotifications) $rootScope.unreadMessageNotifications = 0;
		// 			$rootScope.unreadMessageNotifications = $rootScope.unreadMessageNotifications + 1;
		// 		})
		// 	}
		// 	if ($rootScope.currentCompany) {
		// 		var currentNameSlug = localStorage.getItem('currentCompany');
		// 		SocketService.on('company:' + currentNameSlug + ':notifications:new', function (data) {
		// 			sendBrowserNotification(data.message[$rootScope.language]);
		// 			$rootScope.currentCompany.notifications.push(data);
		//
		// 			$rootScope.$apply();
		// 			var media = '/public/media/notification.mp3'
		// 			var audio = new Audio(media);
		// 			audio.play();
		// 		})
		//
		// 		SocketService.on('company:' + currentNameSlug + ':messagenotifications:new', function (data) {
		// 			sendBrowserNotification(data.message[$rootScope.language]);
		// 			$rootScope.currentCompany.messageNotification.unshift(data);
		//
		// 			$rootScope.$apply();
		// 			var media = '/public/media/notification.mp3'
		// 			var audio = new Audio(media);
		// 			audio.play();
		// 		})
		//
		// 		SocketService.on('company:' + currentNameSlug + ':notifications:unread', function (data) {
		// 			$rootScope.unreadNotifications = data;
		// 			$rootScope.changeTitle();
		// 		})
		//
		// 		SocketService.on('company:' + currentNameSlug + ':messagenotifications:unread', function (data) {
		// 			if (!$rootScope.unreadMessageNotifications) $rootScope.unreadMessageNotifications = 0;
		// 			$rootScope.unreadMessageNotifications = $rootScope.unreadMessageNotifications + 1;
		// 		})
		// 	}
		// }

		$rootScope.changeTitle = function () {
			var title = "PrismaNote"
			if ($state.$current.data && $state.$current.data.pageTitle) {
				title = title + " | " + $language.translate($state.$current.data.pageTitle)
			}

			// if ($rootScope.unreadNotifications > 0) {
			// 	title = '(' + $rootScope.unreadNotifications + ') ' + title;
			// }

			$rootScope.pageTitle = title
			//Write also direct to document to show the result directly
			document.title = title;
		}

		$rootScope.setWindowSize = function (width) {
			$rootScope.innerWidth = width;
			$rootScope.mobile = false;
			$rootScope.tablet = false;

			if (width < 768 || $rootScope.checkMobile()) {
				$rootScope.userDeviceType = 'mobile';
				$rootScope.bootstrapSize = 'xs'
				$rootScope.mobile = true;
			} else if (width >= 768 && width < 992 || $rootScope.checkMobileAndTablet()) {
				$rootScope.userDeviceType = 'tablet';
				$rootScope.bootstrapSize = 'sm';
				$rootScope.tablet = true;
			} else if (width >= 992 && width < 1200) {
				$rootScope.userDeviceType = 'desktop';
				$rootScope.bootstrapSize = 'md';
			} else if (width >= 1200) {
				$rootScope.userDeviceType = 'desktop';
				$rootScope.bootstrapSize = 'lg';
			}
		}

		$rootScope.setWindowSize($window.innerWidth);

		$rootScope.awsUrl = getAwsURL();
		$rootScope.packageModalOpen = false;

		function canEmployeeChangeTheShop() {
			var hasShopChangeAccess = false;
			if (!$rootScope.currentEmployee || ($rootScope.currentEmployee && $rootScope.currentEmployee._id && $rootScope.user._id &&
				($rootScope.currentEmployee._id).toString() === ($rootScope.user._id).toString())) {
				hasShopChangeAccess = true;
			}

			return hasShopChangeAccess;
		}

		$rootScope.checkChangeShopAllowed = function () {
			var forbiddenStates = [
				'retailer.edit-product',
				'retailer.service-item',
				'retailer.purchase-order',
				'retailer.customer',
				'retailer.assortment',
				'retailer.supplier',
				'retailer.orderDetails',
				'retailer.paidcampaign',
				'retailer.news-item',
				'retailer.checkout.start',
				'retailer.state-overview-detail',
				'retailer.checkout.completed',
				'retailer.state-overview-detail',
				'retailer.upgrade',
				'retailer.recommendation-order',
				'brand.employee',
				'brand.service-item',
				'brand.shop-detail',
				'brand.purchase-order',
				'brand.edit-product',
				'brand.updatecampaign',
				'brand.campaigndetail',
				'brand.add-product',
				'brand.edit-product',
				'brand.add-purchase-product',
				'brand.edit-purchase-product',
			]

			return (forbiddenStates.indexOf($state.current.name) == -1 && canEmployeeChangeTheShop());
		}

		//$rootScope.language = $translate.use().substring(0,2);
		$rootScope.currency = 'eur';

		$rootScope.guest = false;

		$transitions.onSuccess({
			to: "layout.**"
		}, function (transition) {
			if (transition.$to().data && transition.$to().data.pageTitle) {
				$rootScope.pageTitle = 'PrismaNote | ' + transition.$to().data.pageTitle;
			} else {
				$rootScope.pageTitle = 'PrismaNote';
			}
		});

		$transitions.onSuccess(true, function () {
			$rootScope.$state = $state;
			$rootScope.transactionType = null;

			$rootScope.top();
			$api.resetApiParams();

			$rootScope.changeTitle();
		});

		//Checks if the currentShop has access to an module. Returns promise, if no access, it wil reject
		$rootScope.checkModule = function (mod, message, directRedirect) {
			function showMessage() {
				return $q(function (resolve, reject) {
					if (message === true && $rootScope.packageModalOpen === false) {
						$rootScope.packageModalOpen = true;
						dlg = dialogs.confirm(
							$language.translate('NOTIFICATION'),
							$language.translate("UPGRADE_YOUR_ACCOUNT_TO_ACCESS_THIS_FUNCTION"), {
							animation: true,
							backdropClass: 'unlock-backdrop',
							btnMessages: {
								'DIALOGS_YES': $language.translate("MORE_INFORMATION"),
								'DIALOGS_NO': $language.translate('BACK')
							},
							size: 'md'
						})
							.result
							.then(
								function () {
									$rootScope.packageModalOpen = false;
									return reject('UPGRADE');
								},
								function () {
									$rootScope.packageModalOpen = false;
									return reject();
								}
							)
							.catch( function (reason){
								console.error('Error upgrading', reason)
							})
					} else {
						return reject();
					}
				})
			}

			return $q(function (resolve, reject) {
				if (!$rootScope.currentShop) {
					$retailer.getShop()
						.then(function (shop) {
							$rootScope.currentShop = shop;
							check();
						})
						.catch( function(reason){
							console.error('Error getting shop', reason)
						})
				} else {
					check();
				}

				function check() {
					if (!$rootScope.currentShop || !$rootScope.currentShop.package ||
						!$rootScope.currentShop.package.modules || $rootScope.currentShop.package.modules.length == 0 ||
						!mod || mod === '') {
						return resolve();
					}

					var index = _.findIndex($rootScope.currentShop.package.modules, {
						name: mod
					});

					if (index >= 0) {
						if ($rootScope.currentShop.package.modules[index].active === false) {
							showMessage()
								.then(function () {
									return reject();
								}).catch(function (reason) {
									return reject(reason);
								})
						} else {
							return resolve();
						}
					} else {
						showMessage()
							.then(function () {
								return reject();
							}).catch(function (reason) {
								if (directRedirect === true && reason == 'UPGRADE') {
									$state.transitionTo('retailer.upgrade');
								}
								return reject(reason);
							})
					}
				}
			})
		}


		$transitions.onStart({
			to: "**"
		}, function (transition) {

			checkRestricted();

			function checkRestricted() {
				if (transition.$to().data && transition.$to().data.restricted) {
					var shopSlug = localStorage.getItem('currentShop');
					var companySlug = localStorage.getItem('currentCompany');
					var data = { reload: true, shopSlug: shopSlug, companySlug: companySlug }

					checkLogin(data, function (err, user) {
						if (err) {
							//No user, or error during login
							var state = $rootScope.user || $rootScope.currentEmployee ? 'retailer.no-right' : 'layout.access-denied'
							return $state.transitionTo(state, {
								to: transition.$to().name
							});
						}
						if (transition.$to().data.role && transition.$to().data.role != "") {
							// specific role required
							// if (($location.path() == '/retailer/employees' && $rootScope.currentEmployee) || !user || user.role != transition.$to().data.role) {
							if (!user || user.role != transition.$to().data.role) {
								return $state.transitionTo("layout.access-denied", {
									to: transition.$to().name
								});
							} else {
								return checkModule();
							}
						} else {
							//only login is required
							if (!user) {
								return $state.transitionTo("layout.access-denied", {
									to: transition.$to().name
								});
							} else {
								return checkModule();
							}
						}
					})
				} else {
					return checkModule();
				}
			}

			function checkModule() {
				if ($rootScope.user && $rootScope.user.role !== 'retailer') {
					return;
				}
				if (transition.$to().data && transition.$to().data.module) {
					$rootScope.checkModule(transition.$to().data.module, true)
						.then(function () {
							return checkEmployee();
						})
						.catch(function (reason) {
							if (reason == 'UPGRADE') {
								return $state.transitionTo('retailer.upgrade');
							}
							if (transition.$from().name && transition.$to().name != transition.$from().name) {
								return $state.transitionTo(transition.$from().name);
							} else {
								return $state.transitionTo('retailer.home');
							}
						})
				} else {
					return checkEmployee();
				}
			}

			function checkEmployee() {
				if (transition.$to().parent && transition.$to().parent.name == 'retailer') {
					$rootScope.checkEmployee();
				}

				if (transition.$to().data && transition.$to().data.rights) {
					if ($rootScope.currentEmployee) {
						if ($rootScope.currentEmployee.rights && $rootScope.currentEmployee.rights.length !== 0) {
							// Only check the rights on the user when they are there. Because 0 rights means full access
							var counter = 0
							for (var i = 0; i < $rootScope.currentEmployee.rights.length; i++) {
								if ($rootScope.currentEmployee.rights[i] === transition.$to().data.rights) {
									// No need to check further rights, let's go!
									return checkRestricted()
								}
								counter++
								if (counter === $rootScope.currentEmployee.rights.length) {
									return $state.transitionTo('retailer.no-rights')
								}
							}
						}
					}
				} else {
					return
				}
			}
		})

		$rootScope.getLogo = function() {
			//Little surprise from Erik and Niek
			if($rootScope.companyLogo) {
				return $rootScope.companyLogo
			}
			var date = new Date()
			var month = date.getMonth()

			if(month === 11) {
				return '../public/icoon_dec.png'
			} else {
				return '../public/icoon.png'
			}
		}

		$rootScope.redirectToDashboard = function () {
			var role = $rootScope.user.role == 'wholesaler' ? 'brand' : $rootScope.user.role;
			$state.go(role + ".home");
		}

		$rootScope.top = function () {
			$window.scrollTo(0, 0);
		};

		$rootScope.currentYear = new moment().format('Y')

		$rootScope.nl2br = function (str, is_xhtml) {
			var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
			return (str + '').trim().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
		};

		$rootScope.truncateText = function (text, length) {
			if (!text) {
				return;
			}
			if (!length) {
				length = 140;
			}
			if (text.indexOf(' ', length) == -1) {
				return text;
			} else {
				return text.substring(0, text.indexOf(' ', length)) + ' ...';
			}
		};

		$rootScope.makeFullCustomerName = function (customer) {
			if (!customer) {
				return
			}
				if(customer && customer.length > 0) {
					var result = ''
					if (customer[0].companyName) result += customer[0].companyName
					if (customer[0].companyName && (customer[0].firstName || customer[0].lastName)) result += ' - '
					if (customer[0].firstName) result += customer[0].firstName
					if (customer[0].prefix) result += ' ' + customer[0].prefix
					if (customer[0].lastName) result += ' ' + customer[0].lastName
					return result

				} else {
					var result = ''
					if (customer.companyName) result += customer.companyName
					if (customer.companyName && (customer.firstName || customer.lastName)) result += ' - '
					if (customer.firstName) result += customer.firstName
					if (customer.prefix) result += ' ' + customer.prefix
					if (customer.lastName) result += ' ' + customer.lastName
					return result
				}
		}
		
		$rootScope.formatDate = function (dateString, short) {
			// TODO make a multilingual formatDate function using angular-translate
			var result = "";
			var monthNames = [
				"januari", "februari", "maart",
				"april", "mei", "juni", "juli",
				"augustus", "september", "oktober",
				"november", "december"
			];

			if (dateString) {
				var date = new Date(dateString);
				if (short === true) {
					result = '' + date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
				} else {
					result = '' + date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear() + ' om ' + date.getHours() + ":" + ('0' + date.getMinutes()).slice(-2) + " uur";
				}
			}

			return result;
		};

		$rootScope.randomNumber = function (min, max) {
			return Math.floor(Math.random() * (max - min + 1) + min);
		};

		$rootScope.setUserInChat = function () {
			if(window.fcWidget) {
				//1. first getting user
				window.fcWidget.user.get().then(function (user) {
					if(user.success) {
						var fullUserName = user.data.firstName ? user.data.firstName + ' ' : '' + user.data.lastName ? user.data.lastName : ''
						if(fullUserName.toUpperCase() !== localStorage.getItem('currentUserName').toUpperCase()) {
							//2. update user
							window.fcWidget.user.update({
								firstName: $rootScope.user.firstName ? $rootScope.user.firstName + ' ' : '',
								lastName: ($rootScope.user.lastNamePrefix ? $rootScope.user.lastNamePrefix + ' ' : '') + ($rootScope.user.lastName ? $rootScope.user.lastName : ''),
								email: $rootScope.user.email,
								identifier: $rootScope.user._id,
								meta: {
									shop: localStorage.getItem('currentShopName'),
									userId: $rootScope.user._id,
									role: $rootScope.user.role
								}
							})
							.then(function () {

							}, function (reason) {
							})
						}
					} else {
						//Create user
						window.fcWidget.user.create({
							firstName: $rootScope.user.firstName ? $rootScope.user.firstName : '',
							lastName: ($rootScope.user.lastNamePrefix ? $rootScope.user.lastNamePrefix : '') + ($rootScope.user.lastName ? $rootScope.user.lastName : ''),
							email: $rootScope.user.email,
							externalId: $rootScope.user._id,
							identifier: $rootScope.user._id,
							meta: {
								shop: localStorage.getItem('currentShopName'),
								userId: $rootScope.user._id,
								role: $rootScope.user.role
							}
						})
							.then(function () {
								console.info('user created in chat')
							}, function (reason) {
								console.error('user not created in chat', reason)
							})
					}
				}).catch( function(reason){
					console.error('Error setting user in chat', reason)
				})
			}
		}
		$rootScope.checkLogin = function (data, callback) {
			return checkLogin(data, callback);
		}

		function checkLogin(data, callback) {
			var reloadData = data.reload;
			$api.get('checklogin', data).then(function (response) {
				if (response.data.user != null) {
					if (reloadData) {
						$rootScope.user = response.data.user;
						localStorage.setItem('currentUserName', $rootScope.user.firstName + ($rootScope.user.lastNamePrefix ? ' ' + $rootScope.user.lastNamePrefix : '') + ' ' + $rootScope.user.lastName)
					}
					$rootScope.setUserInChat()
					return callback(null, response.data.user);
				} else {
					return callback(response.data.message, null);
				}
			}).catch(function (reason) {
				console.error('Error in checklogin', reason);
				return callback(reason, null);
			});
		}

		$rootScope.changeLanguage = function (langKey) {
			moment.locale(langKey)
			if (langKey) {
				if (langKey.length == 2) {
					$translate.use(langKey.toLowerCase() + "_" + langKey.toUpperCase());
					$rootScope.language = langKey;
				} else if (langKey.length == 5) {
					$translate.use(langKey);
					$rootScope.language = langKey.substring(0, 2);
				}
			}
		};

		$rootScope.shopFilter = ''
		$rootScope.updateShopFilter = function(value) {
			$rootScope.shopFilter = value
		}

		$rootScope.$on('$translateChangeSuccess', function () {
			if ($translate.use()) {
				$rootScope.language = $translate.use().substring(0, 2);
				localStorage.setItem("language", $rootScope.language);
				lang = $rootScope.language;
				if ($state.$current && !$state.$current.self.abstract) {
					$rootScope.$broadcast('after_translate_clear_the_product');
					$state.reload();
				}
				moment.locale($rootScope.language)
			}
		});
		$rootScope.changeLanguage($translate.use());

		var shopSlug = localStorage.getItem('currentShop');
		var companySlug = localStorage.getItem('currentCompany');
		checkLogin({ reload: true, shopSlug: shopSlug, companySlug: companySlug }, function (err, user) { // OPTIONAL: do something with the data
		});

		$rootScope.getShopType = function () {

			var hostnames = ['prismanote.com', 'nieuw.prismanote.com', '127.0.0.1', 'localhost', 'prismanote.ngrok.io', 'goedenoot.nl', 'prisma.note'];

			if (hostnames.indexOf(window.location.hostname) == -1) {
				return "proshop";
			} else {
				return "shop";
			}
		}

		$rootScope.testing = function () {
			var test = false;
			var hostnames = ['goedenoot.nl'];

			test = hostnames.indexOf(window.location.hostname) != -1;

			return test;
		}

		$rootScope.getOrderStatus = function (order, returnType) {
			if (returnType && returnType == 'object') {
				return order.status[order.status.length - 1];
			} else {
				return order.status[order.status.length - 1].status;
			}
		}

		$rootScope.startWebshopStatusInterval = function () {
			if($rootScope.connectionLosed === true) {
				return
			}
			//first call the function to show the counter directly, after start we start a interval
			$retailer.getShop()
				.then(function (shop) {

					if(typeof shop.isShopActive !== 'undefined' && shop.isShopActive === false) {
						return //no need to check for order count when the shop doesn't use webshop module
					}

					$api.get('webshop-orders-count/' + shop._id)
						.then(function (result) {
							$rootScope.newWebshopOrders = result.data.count
							// now we start the interval for every 3 minutes
							$interval(function () {
								$api.get('webshop-orders-count/' + shop._id)
									.then(function (result) {
										$rootScope.newWebshopOrders = result.data.count
									})
									.catch(function (reason) {
										console.error('Error while fetching new webshop orders count', reason)
									})
							}, 180000)
						})
						.catch(function (reason) {
							console.error('Error while fetching new webshop orders count', reason)
						})
				})
				.catch(function (reason) {
					console.error('error while fetching shop', reason)
				})
		}
		$rootScope.startWebshopStatusInterval()

		$rootScope.slugify = function (text) {
			return text.toString().toLowerCase()
				.replace(/\s+/g, '-') // Replace spaces with -
				.replace(/[^\w\-]+/g, '') // Remove all non-word chars
				.replace(/\-\-+/g, '-') // Replace multiple - with single -
				.replace(/^-+/, '') // Trim - from start of text
				.replace(/-+$/, ''); // Trim - from end of text
		}

		$rootScope.getSpecificOrderStatus = function (order, status) {
			for (var i = 0; i < order.status.length; i++) {
				if (order.status[i].status == status) {
					return order.status[i];
				}
			}
		}

		$rootScope.consumerHeaderHide = false;
		if ($location.$$path == '/welcome-retailer/' || $location.$$path == '/home/') {
			$rootScope.consumerHeaderHide = true;
		}

		$rootScope.timestamp = new Date().getTime();

		//Those placeholders can be used on labels
		$rootScope.labelPlaceholders = [
			{
				name: '%%PRODUCT_NAME%%',
				value: 'name',
				keyword: 'NAME',
			}, {
				name: '%%SELLING_PRICE%%',
				value: 'sellingPrice',
				keyword: 'TEXT_RECOMMENDED_PRICE',
			},
			{
				name: '%%PRODUCT_NUMBER%%',
				value: 'variants[0].productNumber',
				keyword: 'TEXT_PRODUCT_NUMBER',
			},
			{
				name: '%%ARTICLE_NUMBER%%',
				value: 'articleNumber',
				keyword: 'ARTICLE_NUMBER',
			},
			{
				name: '%%BRAND_NAME%%',
				value: 'brand.name',
				keyword: 'BRAND',
			},
			{
				name: '%%EAN%%',
				value: 'variants[0].ean',
				keyword: 'EAN',
			},
			{
				name: '%%DIAMONDINFO%%',
				value: 'diamondinfo',
				keyword: 'DIAMONDINFO',
			},
			{
				name: '%%PRODUCT_WEIGHT%%',
				value: 'weight',
				keyword: 'WEIGHT',
			},
			{
				name: '%%DESCRIPTION%%',
				value: 'labelDescription',
				keyword: 'LABEL_DESCRIPTION'
			},
			{
				name: "%%MY_OWN_COLLECTION%%",
				value: 'ownCollection',
				keyword: 'OWN_COLLECTION'
			},
			{
				name: "%%VARIANTS_COLLECTION%%",
				value: 'variantsCollection',
				keyword: 'VARIANTSCOLLECTION'
			},
			{
				name: "%%BRAND_COLLECTION1%%",
				value: 'brandCollection1',
				keyword: 'FIRST_BRANDCOLLECTION'
			},
			{
				name: "%%BRAND_COLLECTION2%%",
				value: "brandCollection2",
				keyword: 'SECOND_BRANDCOLLECTION'
			},
			{
				name: "%%TOTALCARATWEIGHT%%",
				value: 'totalCaratWeight',
				keyword: 'TOTAL_CARAT_WEIGHT'
			},
			{
				name: "%%LAST_DELIVIERY_DATE%%",
				value: 'lastDeliveryDate',
				keyword: 'LAST_DELIVERY_DATE'
			},
			{
				name: "%%SUPPLIER_NAME%%",
				value: 'supplier.name',
				keyword: 'SUPPLIER_NAME'
			},
			{
				name: "%%SUPPLIER_CODE%%",
				value: 'supplier.startingDigits',
				keyword: 'SUPPLIER_CODE'
			},
			{
				name: '%%SUGGESTED_RETAIL_PRICE%%',
				value: 'suggestedRetailPrice',
				keyword: 'SUGGESTED_RETAIL_PRICE'
			},
			{
				name: '%%PRODUCT_CATEGORY%%',
				value: 'category',
				keyword: 'PRODUCT_CATEGORY'
			},
			{
				name: '%%PRODUCT_SIZE%%',
				value: 'size',
				keyword: 'SIZE'
			},
			{
				name: '%%JEWEL_TYPE%%',
				value: 'jewel.type',
				keyword: 'JEWEL_TYPE'
			},
			{
				name: '%%JEWEL_MATERIAL%%',
				value: 'jewel.material',
				keyword: 'JEWEL_MATERIAL'
			},
			{
				name: '%%STRAP_WIDTH%%',
				value: 'strap.width',
				keyword: 'STRAP_WIDTH'
			},
			{
				name: '%%STRAP_MATERIAL%%',
				value: 'strap.material',
				keyword: 'STRAP_MATERIAL'
			}
		]

		$rootScope.startIdleTimer = function () {
			var enabled = true;
			if ($rootScope.currentShop && $rootScope.currentShop.employees && $rootScope.currentShop.employees.length > 0 && enabled) {
				var lockTimeOut = 60;
				if ($rootScope.currentShop.employeeLockTime) lockTimeOut = ($rootScope.currentShop.employeeLockTime) * 60;
				Idle.setIdle(lockTimeOut);
				Idle.watch();
			}
		}

		$rootScope.stopIdleTimer = function () {
			Idle.unwatch();
		}

		$rootScope.$on('IdleStart', function () {
			$employee.openWarningModal();
		})

		$rootScope.$on('IdleEnd', function () {
			if ($rootScope.warningModal) {
				$rootScope.warningModal.close();
			}
		})

		$rootScope.$on('IdleTimeout', function () {
			$employee.openEmployeeModal();
		})

		$rootScope.checkEmployee = function () {
			if ($rootScope.currentShop) {
				// Below lines is checking that isEmployeeLogin is disable for this particular device or not
				var isEmployeeLogin = true;
				var isEnableEmployeeLoginForThisDevice = localStorage.getItem('isEnableEmployeeLogin');
				isEnableEmployeeLoginForThisDevice = (isEnableEmployeeLoginForThisDevice == 'true' || isEnableEmployeeLoginForThisDevice == true) ? true : false;
				var isEnableEmployeeLoginForAllDevice = $rootScope.currentShop.isEmployeeLoginEnable;
				if (!isEnableEmployeeLoginForThisDevice || !isEnableEmployeeLoginForAllDevice) isEmployeeLogin = false;
				if ($rootScope.currentShop.employees && $rootScope.currentShop.employees.length && isEmployeeLogin) {
					$employee.getEmployee()
						.then(function (ep) {
							var canAccess = $rootScope.hasAccessToViewPage();
							if (!canAccess) $state.go("retailer.home");
							$rootScope.startIdleTimer();
						}).catch(function (reason) {
							if($rootScope.checkEmployeeModalNecessity($rootScope.user)) {
								$employee.openUnlockModal()
							}
						})
				}
			} else {
				$retailer.getShop()
					.then(function (shop) {
						$rootScope.currentShop = shop;
						return $rootScope.checkEmployee();
					})
					.catch(function (reason) {
						console.error('Error getting shop: ', reason);
					})
			}
		}

		$rootScope.closeNotice = function () {
			var date = new Date()

			if(date.getMonth() === 8 && date.getDate() === 4) {
				localStorage.setItem('noticeAlert2', 'hide')
			}else {
				localStorage.setItem('noticeAlert', 'hide')
			}
			$rootScope.noticeAlert()
		}

		$rootScope.noticeAlert = function() {
			var date = new Date()
			var value = localStorage.getItem(date.getMonth() === 8 && date.getDate() === 4 ? 'noticeAlert2' : 'noticeAlert')

			return value !== 'hide'
		}

		$rootScope.userRights = [
			{
				name: 'USE_SERVICE_APP',
				description: "CREATE_TRANSACTIONS_REPAIRS_SPECIALS_IN_SERVICE_APP",
				value: 'serviceapp',
				enabled: true
			},
			{
				name: 'MANAGE_CUSTOMERS',
				description: 'SEE_EDIT_AND_DELETE_CUSTOMERS',
				value: 'customers',
				enabled: true
			},
			{
				name: 'MANAGE_SUPPLIERS',
				description: "MANAGE_SUPPLIERS_AND_PURCHASE_ORDERS",
				value: 'suppliers',
				enabled: true
			},
			{
				name: 'MANAGE_TRANSACTIONS_OFFERS',
				description: "SEE_HANDLE_TRANSACTIONS_AND_OFFERS",
				value: 'transaction_offer',
				enabled: true
			},
			{
				name: 'MANAGE_REPAIRS_SPECIAL',
				description: "SEE_HANDLE_AND_MANAGE_REPAIRS_AND_SPECIAL_REQUESTS",
				value: 'repairs_special',
				enabled: true
			},
			{
				name: 'MANAGE_WEBSHOP_ORDER',
				description: "HANDLE_WEBSHOP_ORDERS",
				value: 'webshop_order',
				enabled: true
			},
			{
				name: 'MANAGE_DAYSTATE',
				description: "SEE_AND_CREATE_DAYSTATES",
				value: 'daystate',
				enabled: true
			},
			{
				name: 'MANAGE_PRODUCTS',
				value: 'products',
				description: 'MANAGE_PRODUCTS_IMPORTS_AND_ASSORTMENT',
				enabled: true
			},
			{
				name: 'STATISTICS',
				value: 'statistics',
				description: "SEE_SHOP_STATISTICS",
				enabled: true
			},
			{
				name: 'MANAGE_SOCIALMEDIA_ACTIONS',
				description: "SEE_AND_CREATE_SOCIAL_MEDIA_ACTIONS",
				value: 'socialmedia',
				enabled: true
			},
			{
				name: 'MANAGE_NEWS',
				description: "SEE_AND_MANAGE_NEWS_ARTICLES",
				value: 'news',
				enabled: true
			},
			{
				name: 'USE_WEBSITEBUILDER',
				description: "USE_THE_WEBSITEBUILDER",
				value: 'websitebuilder',
				enabled: true
			},
			{
				name: 'MANAGE_SHOP_SETTINGS',
				description: "SEE_AND_EDIT_SHOP_SETTINGS_THIS_ALSO_INCLUDES_MANAGE_EMPLOYEES",
				value: 'shop_settings',
				enabled: true
			}
		]

		//CAUTION: CHANGES IN THE MODULE NAMES MUST BE MAYBE ALSO APPLIED IN admin-shop-controller.js
		$rootScope.packages = [{
			name: 'CASH_AND_CRM',
			price: 39.00,
			contents: [
				'PACKAGE_CUSTOMER_MANAGEMENT',
				'PACKAGE_CHECKOUT_AND_OFFERS',
				'PACKAGE_PROCESS_REPAIRS',
				'PACKAGE_PRINT_RECEIPT',
				'PACKAGE_SALES_STATISTICS',
				'PACKAGE_MARKETING_WITH_SUPPLIERS'
			]
		}, {
			name: 'COMPLETE_STORESYSTEM',
			price: 99.95,
			contents: [
				'PACKAGE_ALL_FUNCTIONS_FROM_CASH_AND_CRM',
				'',
				'PACKAGE_STOCK_MANAGEMENT',
				'PACKAGE_LINK_WITH_PRODUCT_DATABASE',
				'PACKAGE_SUPPLIER_MANAGEMENT',
				'PACKAGE_STATISTICS',
				'PACKAGE_PRINT_LABELS',
				'PACKAGE_PURCHASE_ORDERS',
			]
		}, {
			name: 'OMNICHANNEL_SYSTEM',
			price: 149.95,
			contents: [
				'PACKAGE_ALL_FUNCTIONS_FROM_COMPLETE_STORESYSTEM',
				'',
				'PACKAGE_SHOW_STOCK_ON_SITE',
				'PACKAGE_EDIT_YOUR_OWN_SITE',
				'PACKAGE_SELL_DIRECTLY_ON_YOUR_WEBSHOP',
				'PACKAGE_SHARE_BLOGS_AND_PHOTOS_WITH_1_CLICK',
				'PACKAGE_AUTOMATIC_UPDATES',
			]
		},
		{
			name: 'SELL_PACKAGE',
			price: 249.95,
			contents: [
				'PACKAGE_ALL_FUNCTIONS_FROM_OMNICHANNEL_SYSTEM',
				'',
				'PACKAGE_SEND_NEWSLETTER_EVERY_MONTH',
				'PACKAGE_UPDATE_WEBSITE_TEXTS_AND_PHOTOS',
				'PACKAGE_MANAGE_SOCIAL_MEDIA_CHANNELS',
				'PACKAGE_THINK_ALONG_DIGITIZING_WEBSHOP'
			]
		}
		]

		$rootScope.displayUserFullName = function (user) {
			if (!user) return $language.translate("UNKNOWN");
			return user.firstName + ' ' + (user.lastNamePrefix ? user.lastNamePrefix + ' ' : '') + user.lastName;
		}

		$rootScope.resetCurrentFilters = function () {

		}
		// $rootScope.userRights = [
		// 	{
		// 		name: 'MANAGE_PRODUCTS',
		// 		description: 'MANAGE_PRODUCTS_IMPORTS_AND_ASSORTMENT',
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'STATISTICS',
		// 		description: "SEE_SHOP_STATISTICS",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_TRANSACTIONS_OFFERS',
		// 		description: "SEE_HANDLE_TRANSACTIONS_AND_OFFERS",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_REPAIRS_SPECIAL',
		// 		description: "SEE_HANDLE_AND_MANAGE_REPAIRS_AND_SPECIAL_REQUESTS",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_WEBSHOP_ORDER',
		// 		description: "HANDLE_WEBSHOP_ORDERS",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_CUSTOMERS',
		// 		description: 'SEE_EDIT_AND_DELETE_CUSTOMERS',
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_SUPPLIERS',
		// 		description: "MANAGE_SUPPLIERS_AND_PURCHASE_ORDERS",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_SOCIALMEDIA_ACTIONS',
		// 		description: "SEE_AND_CREATE_SOCIAL_MEDIA_ACTIONS",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_NEWS',
		// 		description: "SEE_AND_MANAGE_NEWS_ARTICLES",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'USE_WEBSITEBUILDER',
		// 		description: "USE_THE_WEBSITEBUILDER",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_SHOP_SETTINGS',
		// 		description: "SEE_AND_EDIT_SHOP_SETTINGS_THIS_ALSO_INCLUDES_MANAGE_EMPLOYEES",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'USE_SERVICE_APP',
		// 		description: "CREATE_TRANSACTIONS_REPAIRS_SPECIALS_IN_SERVICE_APP",
		// 		enabled: false
		// 	},
		// 	{
		// 		name: 'MANAGE_DAYSTATE',
		// 		description: "SEE_AND_CREATE_DAYSTATES",
		// 		enabled: false
		// 	}
		// ]

		//CAUTION: CHANGES IN THE MODULE NAMES MUST BE MAYBE ALSO APPLIED IN admin-shop-controller.js
		$rootScope.packages = [{
			name: 'CASH_AND_CRM',
			price: 39.00,
			contents: [
				'PACKAGE_CUSTOMER_MANAGEMENT',
				'PACKAGE_CHECKOUT_AND_OFFERS',
				'PACKAGE_PROCESS_REPAIRS',
				'PACKAGE_PRINT_RECEIPT',
				'PACKAGE_SALES_STATISTICS',
				'PACKAGE_MARKETING_WITH_SUPPLIERS',
				'PACKAGE_EMPLOYEES'
			]
		}, {
			name: 'COMPLETE_STORESYSTEM',
			price: 99.95,
			contents: [
				'PACKAGE_ALL_FUNCTIONS_FROM_CASH_AND_CRM',
				'',
				'PACKAGE_STOCK_MANAGEMENT',
				'PACKAGE_LINK_WITH_PRODUCT_DATABASE',
				'PACKAGE_SUPPLIER_MANAGEMENT',
				'PACKAGE_STATISTICS',
				'PACKAGE_PRINT_LABELS',
				'PACKAGE_PURCHASE_ORDERS',
			]
		}, {
			name: 'OMNICHANNEL_SYSTEM',
			price: 149.95,
			contents: [
				'PACKAGE_ALL_FUNCTIONS_FROM_COMPLETE_STORESYSTEM',
				'',
				'PACKAGE_SHOW_STOCK_ON_SITE',
				'PACKAGE_EDIT_YOUR_OWN_SITE',
				'PACKAGE_SELL_DIRECTLY_ON_YOUR_WEBSHOP',
				'PACKAGE_SHARE_BLOGS_AND_PHOTOS_WITH_1_CLICK',
				'PACKAGE_AUTOMATIC_UPDATES',
			]
		},
		{
			name: 'SELL_PACKAGE',
			price: 249.95,
			contents: [
				'PACKAGE_ALL_FUNCTIONS_FROM_OMNICHANNEL_SYSTEM',
				'',
				'PACKAGE_SEND_NEWSLETTER_EVERY_MONTH',
				'PACKAGE_UPDATE_WEBSITE_TEXTS_AND_PHOTOS',
				'PACKAGE_MANAGE_SOCIAL_MEDIA_CHANNELS',
				'PACKAGE_THINK_ALONG_DIGITIZING_WEBSHOP'
			]
		}
		]

		$rootScope.displayUserFullName = function (user) {
			if (!user) return $language.translate("UNKNOWN");
			return user.firstName + ' ' + (user.lastNamePrefix ? user.lastNamePrefix + ' ' : '') + user.lastName;
		}

		$rootScope.multiSelectLang = {
			selectAll: "select all",
			// selectNone: $language.translate('TICK_NONE'),
			// reset: $language.translate('UNDO_ALL'),
			// search: $language.translate('TYPE_HERE_TO_SEARCH'),
			// nothingSelected: $language.translate('ALL')
		}

		$rootScope.checkEmployeeModalNecessity = function(user) {
			if(user && typeof user.isVisible !== 'undefined' && user.isVisible === false) {
				return false
			}
			return true
		}

		// if (document.getElementById('facebook-jssdk')) {
		// 	return;
		// }
		// var firstScriptElement = document.getElementsByTagName('script')[0];
		// var facebookJS = document.createElement('script');
		// facebookJS.id = 'facebook-jssdk';
		// facebookJS.src = 'https://connect.facebook.net/en_US/sdk.js';
		// firstScriptElement.parentNode.insertBefore(facebookJS, firstScriptElement);
	}
]);


prismanoteApp.directive('aDisabled', function () {
	return {
		compile: function (tElement, tAttrs, transclude) {
			// Disable ngClick
			tAttrs["ngClick"] = "!(" + tAttrs["aDisabled"] + ") && (" + tAttrs["ngClick"] + ")";

			// return a link function
			return function (scope, iElement, iAttrs) {

				// Toggle "disabled" to class when aDisabled becomes true
				scope.$watch(iAttrs["aDisabled"], function (newValue) {
					if (newValue !== undefined) {
						iElement.toggleClass("disabled", newValue);
					}
				});

				// Disable href on click
				iElement.on("click", function (e) {
					if (scope.$eval(iAttrs["aDisabled"])) {
						e.preventDefault();
					}
				});
			};
		}
	};
});